(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollToReviews() {
    var target = document.getElementById('hpq-reviews');
    if (!target) return;
    target.scrollIntoView({
      behavior: REDUCED_MOTION ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function wireRatings() {
    var section = document.querySelector('.main-product') ||
      document.querySelector('[data-section-type="main-product"]') ||
      document.querySelector('.product-section') ||
      document.body;
    var ratings = section.querySelectorAll('.product-rating');
    ratings.forEach(function (el) {
      if (el.dataset.reviewScrollWired) return;
      el.dataset.reviewScrollWired = '1';
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Jump to reviews');
      el.addEventListener('click', scrollToReviews);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToReviews();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', wireRatings);
  document.addEventListener('hpq:product:swapped', wireRatings);
})();
